import React from 'react'

import { Box } from '../Box/Box'
import { Text } from '../Text/Text'

export interface BadgeProps {
  children: React.ReactNode
  tone: 'light' | 'action' | 'positive' | 'negative' | 'caution' | 'info'
  onMouseDown?: (event: React.MouseEvent<HTMLInputElement>) => void
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void
}

export const Badge: React.FC<BadgeProps> = ({ children, tone = 'light', ...props }) => {
  let badgeColor
  if (tone === 'light') badgeColor = 'var(--colors-background)'
  else badgeColor = `var(--colors-${tone}--subtle)`

  return (
    <Box display="flex">
      <Box
        radius="xxs"
        border={`1px solid ${badgeColor}`}
        background={badgeColor}
        insetSquish="xs"
        {...props}
      >
        <Text size="small" weight="strong" tone={tone}>
          {children}
        </Text>
      </Box>
    </Box>
  )
}
